import { useMemo } from 'react';
import { ThemeColorsValues } from '../../theme';
import { getColorTokenName } from '../../utils';

export const useThemeColorVar = (name?: ThemeColorsValues | string | 'inherit') => {
  if (!name) {
    return null;
  }

  if (name === 'inherit') {
    return 'inherit';
  }

  const colorTokenName = useMemo(() => getColorTokenName(name), [name]);
  const value = useMemo(
    () =>
      colorTokenName.variable ? `var(${colorTokenName.value})` : colorTokenName.value,
    [colorTokenName]
  );
  return value;
};
